import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner() {
  const [adminName, setAdminName] = useState("Administer");

  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem("user"));
    if (loginUser) {
      setAdminName(loginUser?.data?.userData?.first_name);
    } else {
      setAdminName("Administer");
    }
  }, []);

  return (
    <div className="container">
      <Row
        className="align-items-center mb-5"
        style={{
          background: "linear-gradient(135deg, #4e54c8, #8f94fb)",
          borderRadius: "23px",
          padding: "20px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
          transition: "all 0.3s ease",
          margin: "0 auto",
        }}
      >
        <Col xs={12} md={8} className="mb-3 mb-md-0">
          <h1
            className="text-white"
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              lineHeight: "1.3",
              textShadow: "2px 2px 6px rgba(0, 0, 0, 0.5)",
            }}
          >
            {`Welcome back`}
          </h1>
          <p
            className="text-white"
            style={{
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "1.5",
              marginTop: "10px",
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.4)",
            }}
          >
            We're glad to see you back. Manage your tasks, check updates, and
            make sure everything is running smoothly.🚀
          </p>
        </Col>

        <Col
          xs={12}
          md={4}
          className="text-center text-md-end d-none d-md-block"
        >
          <img
            src="/Buffer-pana.svg"
            alt="Admin Avatar"
            className="img-fluid"
            style={{
              maxHeight: "350px",
              width: "100%",
              objectFit: "contain",
            }}
          />
        </Col>
      </Row>
    </div>
  );
}

export default Banner;
